import { render, staticRenderFns } from "./HistoryController.vue?vue&type=template&id=3504606a"
import script from "./HistoryController.vue?vue&type=script&lang=js"
export * from "./HistoryController.vue?vue&type=script&lang=js"
import style0 from "./HistoryController.vue?vue&type=style&index=0&id=3504606a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports